import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { arrayToTree } from 'utils/tree';
/* Components */

import Box from 'components/Box';
import EmptyStateController from 'components/EmptyStateController';
import CheckboxOption from 'components/CheckboxOption';
import Landmark from 'components/Landmark';
import { VIEW_KEYS } from 'components/ItemPicker/useItemPickerView';
function TopicSelectorBody(_ref) {
  var view = _ref.view,
    items = _ref.items,
    selectedItems = _ref.selectedItems,
    _ref$indeterminateIte = _ref.indeterminateItems,
    indeterminateItems = _ref$indeterminateIte === void 0 ? [] : _ref$indeterminateIte,
    selectedAndIndeterminateItems = _ref.selectedAndIndeterminateItems,
    _onChange = _ref.onChange,
    isLoading = _ref.isLoading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderTree = useCallback(function (items) {
    var selectedItemIds = selectedItems.map(function (topic) {
      return topic.id;
    });
    return /*#__PURE__*/React.createElement("ul", null, items.map(function (item) {
      var isSelected = selectedItemIds.includes(item.id);
      var isIndeterminate = indeterminateItems.map(function (topic) {
        return topic.id;
      }).includes(item.id);
      var hasChildren = item.children && item.children.length > 0;
      return /*#__PURE__*/React.createElement("li", {
        key: item.id
      }, /*#__PURE__*/React.createElement(CheckboxOption, {
        bold: "auto",
        checked: isSelected,
        indeterminate: isIndeterminate,
        id: "".concat(item.id),
        label: item.name,
        onChange: function onChange() {
          return _onChange(item, isIndeterminate || !isSelected);
        }
      }), hasChildren && /*#__PURE__*/React.createElement(Box, {
        pl: "l"
      }, renderTree(item.children)));
    }));
  }, [selectedItems, indeterminateItems, _onChange]);
  var itemsToRender = view.key === VIEW_KEYS.SELECTED ? selectedAndIndeterminateItems : items;
  return /*#__PURE__*/React.createElement(Box, {
    p: "m"
  }, /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: (itemsToRender === null || itemsToRender === void 0 ? void 0 : itemsToRender.length) === 0 && isLoading,
    isEmpty: (itemsToRender === null || itemsToRender === void 0 ? void 0 : itemsToRender.length) === 0 && !isLoading,
    emptyContent: /*#__PURE__*/React.createElement(Landmark, null, t('alert_no_topics_found'))
  }, itemsToRender ? renderTree(arrayToTree(itemsToRender, null)) : null));
}
export default TopicSelectorBody;